var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "toc-container" }, [
    _c("div", [
      _vm.field.show_checkbox
        ? _c("span", { staticClass: "toc-checkbox" }, [
            _c("input", { attrs: { type: "checkbox" } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", {
        staticClass: "toc-description",
        domProps: { innerHTML: _vm._s(_vm.content) }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }